import moment from 'moment';

const inprogress_fields = {
  'BL/Booking': 'service.doc_number',
  'Servicio': 'service.service_type.name',
  'Llenado en almacén': {
    field: 'fill',
    callback: fill => {
      return fill ? 'SI' : 'NO'
    }
  },
  'Horario de almacén': {
    field: 'date_fill',
    callback: date_fill => {
      return moment(date_fill).isValid() ? moment(date_fill).format('DD/MM/YYYY HH:mm') : ''
    }
  },
  'Depósito de retiro': {
    field: 'deposit_pick',
    callback: deposit_pick => {
      return deposit_pick ? deposit_pick.name : ''
    }
  },
  'Depósito de devolución (impo) o entrega full (expo)': {
    field: 'deposit',
    callback: deposit => {
      return deposit ? deposit.name : ''
    }
  },
  'Fecha (cita)': {
    field: 'date',
    callback: date => {
      return moment(date).isValid() ? moment(date).format('DD/MM/YYYY HH:mm') : ''
    }
  },
  'Contenedor': 'container_number',
  'Tamaño': {
    field: 'container_size',
    callback: container_size => {
      return container_size ? container_size.name : ''
    }
  },
  'Tipo de carga': {
    field: 'charge_type',
    callback: charge_type => {
      return charge_type ? charge_type.name : ''
    }
  },
  'EIR': 'number_eir',
  'Placa': {
    field: 'truck',
    callback: truck => {
      return truck ? truck.plate : ''
    }
  },
  'Conductor': {
    field: 'driver',
    callback: driver => {
      return driver ? `${driver.name} ${driver.last_name}` : ''
    }
  },
  'Celular conductor': {
    field: 'truck',
    callback: truck => {
      return truck ? truck.mobile : ''
    }
  },
  'Estado': 'status.name'
}

export default inprogress_fields;